import React, { useEffect, useState, useRef } from 'react'
import TextField from '@mui/material/TextField'

import Box from '@mui/material/Box'

import Stack from '@mui/material/Stack'
import Grid from '@mui/material/Grid2'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import { styled } from '@mui/material/styles'
import { formatDateToDDMMYYYY } from '../../api/formatDate'
import '../../styles/main.css'
import {
  updateData,
  addData,
  deleteData,
  getData,
  upsertDataTournaments,
  ids,
} from '../../api/indexedDBHandler'
import { useParams } from 'react-router-dom'
import Backdrop from '@mui/material/Backdrop'
import DeleteIcon from '@mui/icons-material/Delete'

import Button from '@mui/material/Button'

import IconButton from '@mui/material/IconButton'
import SmartToyIcon from '@mui/icons-material/SmartToy'
import Modal from '@mui/material/Modal'
import EditSharpIcon from '@mui/icons-material/EditSharp'
import CircularProgress from '@mui/material/CircularProgress'
import StarIcon from '@mui/icons-material/Star'
import ModalAddTeam from '../Modal/ModalAddTeam'

const TeamDrawCardCom = ({
  tournament,
  teamDataTemp,
  athleteDataTemp,
  typeDraw,
  response,
  typeCard,
  ids,
  groupIndex = null,
  responseMeme,
}) => {
  const { id } = useParams()
  const [openBackdrop, setOpenBackdrop] = useState(false)
  const [teamData, setteamData] = useState(null)
  const [athleteData, setathleteData] = useState(null)
  const [comand_name, set_comand_name] = useState(null)
  const inputRef = useRef(null)

  useEffect(() => {
    if (teamDataTemp) {
      setteamData(teamDataTemp)
      if (teamDataTemp.length > 1 && !comand_name) {
        if (teamDataTemp[0]?.comand_name)
          set_comand_name(teamDataTemp[0].comand_name)
        else {
          const detTeamName = async () => {
            let tn = null
            const resultsC = await getData('communication', 'id', id)
            if (resultsC.length > 0) {
              const { key, value } = resultsC[0]
              if (teamDataTemp.length >= 2) {
                const ids = teamDataTemp.slice(1).map((team) => team?.id)
                if (ids.every((id) => value[id])) {
                  tn = value[ids[0]]
                }
              }
            }
            if (!tn) {
              const str1 = name(teamDataTemp[0])
              const str2 = teamDataTemp[1]?.id
                ? ' + ' + name(teamDataTemp[1])
                : ''
              const str3 = teamDataTemp[2]?.id
                ? ' + ' + name(teamDataTemp[2])
                : ''
              tn = str1 + str2 + str3
            }
            set_comand_name(tn)
            responseMeme(tn, ids)
          }
          detTeamName()
        }
      }
    }
  }, [teamDataTemp])
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus()
    }
  }, [comand_name])
  useEffect(() => {
    if (athleteDataTemp) setteamData(athleteDataTemp)
  }, [athleteDataTemp])

  const newName = (name) => {
    console.log('comand_name_change', name)
    set_comand_name(name)
    ids.forEach((item) => {
      const update_data = {
        [item]: name,
        id: id,
      }
      upsertDataTournaments('communication', update_data)

      console.log('update_data', update_data)
    })
    // responseMeme(name, ids)
  }

  const dob_sport_categori = (sports_category, dob) => {
    var arr = []
    if (sports_category) arr.push(sports_category)
    if (dob != '0000-00-00') arr.push(formatDateToDDMMYYYY(dob) + ' г.р.')
    return arr.join(', ')
  }

  const openModalCommunication = () => {
    response(null, ids, 'openModalCommunication')
  }

  const openModalCommunicationGroup = () => {
    response(null, ids, 'openModalCommunicationGroup')
  }

  const dellhandleClick = (eid) => {
    response(null, eid, 'delComunications')
  }

  const notCommunication = () => {
    return (
      <Grid size={{ xs: 12, md: 12 }}>
        <Item
          className="regateam"
          style={{
            padding: '18px',
          }}
        >
          <Stack direction="row" spacing={2} style={{ textAlign: 'left' }}>
            {teamData?.logo && (
              <img
                alt="Logo Team"
                variant="square"
                src={'https://protocarp.ru/' + teamData?.logo}
                style={{ objectFit: 'contain !important', height: '40px' }}
              />
            )}
            <div>
              <Typography
                variant="h6"
                gutterBottom
                style={{ marginBottom: '0px', lineHeight: '1.2' }}
                className="color-text-black"
              >
                {name(teamData)}
              </Typography>
              <Typography variant="caption" gutterBottom>
                {teamData.name}
              </Typography>
            </div>
          </Stack>
          <Stack direction="row" spacing={2} style={{ textAlign: 'left' }}>
            <div>
              {athleteData.map((athlete, index) => (
                <Stack
                  key={athlete.id}
                  direction="row"
                  spacing={2}
                  style={{ textAlign: 'left', paddingTop: '20px' }}
                >
                  <div>
                    <Typography
                      variant="body1"
                      gutterBottom
                      style={{ marginBottom: '0px' }}
                      className="color-text-black"
                    >
                      {athlete.fio}{' '}
                      {athlete.identification == 'идентифицирован' ? (
                        <StarIcon
                          fontSize="small"
                          style={{ fill: '#2a52be' }}
                        />
                      ) : (
                        <></>
                      )}
                    </Typography>
                    <Typography
                      variant="caption"
                      gutterBottom
                      sx={{ display: 'block' }}
                    >
                      {dob_sport_categori(athlete.sports_category, athlete.dob)}
                    </Typography>
                  </div>
                </Stack>
              ))}
            </div>
            <Box sx={{ flexGrow: 1 }} />
            <div>
              <div style={{ textAlign: 'end' }}>
                <Button
                  onClick={openModalCommunication}
                  variant="contained"
                  size="small"
                >
                  Добавить пару в команду
                </Button>
              </div>
            </div>
          </Stack>
        </Item>
      </Grid>
    )
  }

  const сommunication = () => {
    if (athleteData)
      return (
        <Item
          key={athleteData.id}
          className="regateam"
          style={{
            padding: '18px',
            width: '100%',
          }}
        >
          <Grid container spacing={2} style={{ paddingTop: '10px' }}>
            <Grid item size={{ xs: 12, md: 12 }}>
              <TextField
                id="standard-basic"
                label="Название команды  "
                variant="standard"
                fullWidth
                value={comand_name}
                onChange={(e) => newName(e.target.value)}
                inputRef={inputRef}
              />
            </Grid>

            {athleteData.map((team, index) => (
              <Grid item size={{ xs: 12, md: 4 }} key={`athlete-${index}`}>
                <Stack
                  direction="row"
                  spacing={2}
                  style={{ textAlign: 'left' }}
                >
                  <div>
                    <div>
                      <Typography
                        variant="h6"
                        gutterBottom
                        style={{ marginBottom: '0px', lineHeight: '1.2' }}
                        className="color-text-black"
                      >
                        {'пара: ' + name(team.team)}{' '}
                        <IconButton
                          aria-label="delete"
                          size="small"
                          onClick={(e) => dellhandleClick(team.team.id)}
                        >
                          <DeleteIcon
                            fontSize="inherit"
                            style={{ fill: 'red' }}
                          />
                        </IconButton>
                      </Typography>
                    </div>
                    <Typography variant="caption" gutterBottom>
                      {team.team.name}
                    </Typography>
                  </div>
                </Stack>
                <Stack
                  direction="row"
                  spacing={2}
                  style={{ textAlign: 'left' }}
                >
                  <div>
                    {team.athlete.map((athlete, index) => (
                      <Stack
                        key={athlete.id}
                        direction="row"
                        spacing={2}
                        style={{ textAlign: 'left', paddingTop: '20px' }}
                      >
                        <div>
                          <Typography
                            variant="body1"
                            gutterBottom
                            style={{ marginBottom: '0px' }}
                            className="color-text-black"
                          >
                            {athlete.fio}{' '}
                            {athlete.identification == 'идентифицирован' ? (
                              <StarIcon
                                fontSize="small"
                                style={{ fill: '#2a52be' }}
                              />
                            ) : (
                              <></>
                            )}
                          </Typography>
                          <Typography
                            variant="caption"
                            gutterBottom
                            sx={{ display: 'block' }}
                          >
                            {dob_sport_categori(
                              athlete.sports_category,
                              athlete.dob
                            )}
                          </Typography>
                        </div>
                      </Stack>
                    ))}
                  </div>
                </Stack>
              </Grid>
            ))}
          </Grid>
          {Object.keys(teamData).length < 3 && (
            <Button
              onClick={openModalCommunication}
              variant="contained"
              size="small"
              style={{ marginTop: '10px' }}
            >
              Добавить пару в команду
            </Button>
          )}
        </Item>
      )
  }
  const name = (team) => {
    if (tournament.competition_type == 'Рейтинговое соревнование')
      return team?.team_name_ru
    return team?.preferred_name == 'en'
      ? team?.team_name_en
        ? team?.team_name_en
        : team?.team_name_ru
      : team?.team_name_ru
  }
  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    ...theme.applyStyles('dark', {
      backgroundColor: '#1A2027',
    }),
  }))
  useEffect(() => {
    setteamData(teamDataTemp)
  }, [teamDataTemp])

  useEffect(() => {
    setathleteData(athleteDataTemp)
  }, [athleteDataTemp])

  if (teamData)
    return (
      <>
        <Backdrop
          sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
          open={openBackdrop}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        {typeCard === 'Сommunication_null' && notCommunication()}
        {typeCard === 'GroupCommunication' && сommunication()}
      </>
    )
}

export default TeamDrawCardCom
